import axios from 'axios'
import { message } from 'antd'
import i18next from '@/i18n'
import { creatAuth, isValidValue } from '@/utils/cryptoNew'
let browserBaseURL = import.meta.env.VITE_BROWSER_BASE_URL

const instance = axios.create({
  baseURL: browserBaseURL,
  timeout: 100000,
})

instance.interceptors.request.use(
  (config: any) => {
    // 生产环境API地址
    if (import.meta.env.VITE_NODE_ENV !== 'development') {
      const realAPI_Url = window.Global_Front_Api['front_gea_api___gea_scan_api']
      browserBaseURL = realAPI_Url
      // browserBaseURL = '/proxy'
      config.baseURL = browserBaseURL
    }
    const fetchParams = config.method === 'get' ? config.params || {} : config.data || {}
    const paramsObj: Record<string, any> = {}
    Object.keys(fetchParams).forEach((key) => {
      const element = fetchParams[key]
      if (isValidValue(element)) {
        paramsObj[key] = element
      }
    })
    if (config.method === 'get') {
      config.params = paramsObj
    } else {
      config.data = paramsObj
    }
    const auth = creatAuth(config)
    config.headers.Authorization = auth
    return config
  },
  (error) => {
    console.log('requestErr->', error)
  },
)

instance.interceptors.response.use(
  (response: any) => {
    if (response.status !== 200) {
      // todo error tips
      return Promise.reject()
    }
    return response.data
  },
  (error: any) => {
    if ([502, 503, 504, 500].includes(error.response.status)) {
      message.error({
        content: i18next.t('com_error_code').replace('{code}', error?.response?.status),
      })
    } else if (error.response) {
      const { data } = error.response
      const { code, message } = data
      console.error('error-->', code, message)
      message.error({
        content: i18next.t(code, i18next.t('COMM_ERROR_1')),
      })
    }
  },
)

export default instance
